"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Contract = require("@tableau/api-external-contract-js");
var TableauEvent_1 = require("./TableauEvent");
var WorkbookFormattingChangedEvent = /** @class */ (function (_super) {
    __extends(WorkbookFormattingChangedEvent, _super);
    function WorkbookFormattingChangedEvent(_formatting) {
        var _this = _super.call(this, Contract.TableauEventType.WorkbookFormattingChanged) || this;
        _this._formatting = _formatting;
        return _this;
    }
    Object.defineProperty(WorkbookFormattingChangedEvent.prototype, "formatting", {
        get: function () {
            return this._formatting;
        },
        enumerable: true,
        configurable: true
    });
    return WorkbookFormattingChangedEvent;
}(TableauEvent_1.TableauEvent));
exports.WorkbookFormattingChangedEvent = WorkbookFormattingChangedEvent;
//# sourceMappingURL=WorkbookFormattingChangedEvent.js.map